export const INITIAL_YEAR = 2015;



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/constants/reporting.constant.ts